import clsx from 'clsx'
import { useState, type InputHTMLAttributes } from 'react'

import { Input } from './Input'
import { ReactComponent as Eye } from '../../assets/svgs/eye.svg'
import { ReactComponent as EyeSlash } from '../../assets/svgs/eye-slash.svg'

type PasswordInputProps = Omit<
InputHTMLAttributes<HTMLInputElement>,
'type'
> & {
  label: string
  isValid: boolean
  errorMessage?: string
}

export const PasswordInput = ({
  label,
  name,
  isValid,
  errorMessage,
  ...props
}: PasswordInputProps) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  return (
    <Input
      {...props}
      label={label}
      type={isPasswordVisible ? 'text' : 'password'}
      isValid={isValid}
      errorMessage={errorMessage}
      renderEndAdornment={() => (
        <button
          type="button"
          onClick={() => {
            setIsPasswordVisible((prevState) => !prevState)
          }}
        >
          {isPasswordVisible ? (
            <EyeSlash
              className={clsx(
                'text-lg lg:text-2xl',
                { 'text-grey-800': isValid, 'text-alert-error': !isValid }
              )}
            />
          ) : (
            <Eye
              className={clsx(
                'text-lg lg:text-2xl',
                { 'text-grey-800': isValid, 'text-alert-error': !isValid }
              )}
            />
          )}
        </button>
      )}
    />
  )
}
